var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTextStrike(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 15.5H24M20.1429 8.03678C19.8513 7.43967 19.1831 6.91275 18.2484 6.54278C17.3136 6.17281 16.1679 5.98186 15 6.00136H13.7143C12.5208 6.00136 11.3762 6.50173 10.5323 7.3924C9.68839 8.28307 9.21429 9.49108 9.21429 10.7507C9.21429 12.0103 9.68839 13.2183 10.5323 14.109C11.3762 14.9996 12.5208 15.5 13.7143 15.5H16.2857C17.4792 15.5 18.6238 16.0004 19.4677 16.891C20.3116 17.7817 20.7857 18.9897 20.7857 20.2493C20.7857 21.5089 20.3116 22.7169 19.4677 23.6076C18.6238 24.4983 17.4792 24.9986 16.2857 24.9986H14.3571C13.1892 25.0181 12.0436 24.8272 11.1088 24.4572C10.174 24.0873 9.50582 23.5603 9.21429 22.9632",
    stroke: "black",
    strokeWidth: 2.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextStrike);
export default __webpack_public_path__ + "static/media/text-strike.84fe6e62e68d842650841f5deeecf5ad.svg";
export { ForwardRef as ReactComponent };